import EyeIcon from "@/components/icons/eye";
import PencilIcon from "@/components/icons/pencil";
import cn from "@/utils/class-names";
import { Link } from "react-router-dom";
import { ActionIcon, Flex, Tooltip } from "rizzui";
import DeletePopover from "../delete-popover";

export default function TableRowActionGroup({
  onDelete,
  editUrl = "#",
  viewUrl = "#",
  deletePopoverTitle = "Delete the appointment",
  deletePopoverDescription = "Are you sure you want to delete this item?",
  className,
}: {
  onDelete?: () => void;
  editUrl?: string;
  viewUrl?: string;
  deletePopoverTitle?: string;
  deletePopoverDescription?: string;
  className?: string;
}) {
  return (
    <Flex
      align="center"
      justify="end"
      gap="3"
      className={cn("pe-3", className)}
    >
      <Tooltip size="sm" content="Edit Item" placement="top" color="invert">
        <Link to={editUrl}>
          <ActionIcon
            as="span"
            size="sm"
            variant="outline"
            aria-label="Edit Item"
          >
            <PencilIcon className="size-4" />
          </ActionIcon>
        </Link>
      </Tooltip>
      <Tooltip size="sm" content="View Item" placement="top" color="invert">
        <Link to={viewUrl}>
          <ActionIcon
            as="span"
            size="sm"
            variant="outline"
            aria-label="View item"
          >
            <EyeIcon className="size-4" />
          </ActionIcon>
        </Link>
      </Tooltip>
      <DeletePopover
        title={deletePopoverTitle}
        description={deletePopoverDescription}
        onDelete={onDelete}
      />
    </Flex>
  );
}
